import Button from "shared/Button"
import backImg from "../../assets/images/back.svg"
import { useNavigate } from "react-router-dom"
import ItemForm from "./ui/ItemForm"

const NewItems = () => {
    const navigate = useNavigate()

    const backPgae = () => {
        navigate(-1)
    }
    return (
        <>
            <Button disableDefaultStyles type="button" onClick={backPgae} buttonClasses="mt-5 w-5 h-5 md:w-7 md:h-7">
                <img src={backImg} alt="back" />
            </Button>
            <h2 className="mt-5 md:mt-[46px] text-2xl md:text-3xl lg:text-[58px] font-semibold font-poppins lg:leading-[140%] text-foreground">
                Create New Items
            </h2>
            <ItemForm />
        </>
    )
}

export default NewItems